module.exports = __webpack_public_path__ + "img/selected2-min.d9cda093.png";